var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFondoCell(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 779,
    height: 2269,
    viewBox: "0 0 779 2269",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_384_21)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 779,
    height: 2269,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.6426,
    cy: 890.791,
    rx: 281.475,
    ry: 322.75,
    fill: "url(#paint0_radial_384_21)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 550.777,
    cy: 1454.99,
    rx: 190.49,
    ry: 218.423,
    fill: "url(#paint1_radial_384_21)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 779,
    cy: 399.164,
    rx: 190.49,
    ry: 218.423,
    fill: "url(#paint2_radial_384_21)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 79.1168,
    cy: 73.9703,
    rx: 190.49,
    ry: 218.423,
    fill: "url(#paint3_radial_384_21)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_384_21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M517.229 972.627L486.95 988.331L456.67 972.627V941.229L486.95 925.535L517.229 941.229V972.627Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.95 925.535L456.67 941.229L426.379 925.535V894.137L456.67 878.443L486.95 894.137V925.535Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.229 878.444L486.95 894.148L456.67 878.444V847.056L486.95 831.352L517.229 847.056V878.444Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.95 831.352L456.67 847.056L426.379 831.352V799.954L456.67 784.26L486.95 799.954V831.352Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.229 784.26L486.95 799.954L456.67 784.26V752.862L486.95 737.168L517.229 752.862V784.26Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.95 737.168L456.67 752.862L426.379 737.168V705.77L456.67 690.076L486.95 705.77V737.168Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.229 690.076L486.95 705.781L456.67 690.076V658.678L486.95 642.984L517.229 658.678V690.076Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.95 642.983L456.67 658.677L426.379 642.983V611.585L456.67 595.891L486.95 611.585V642.983Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.229 595.891L486.95 611.585L456.67 595.891V564.493L486.95 548.799L517.229 564.493V595.891Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.95 548.8L456.67 564.494L426.379 548.8V517.401L456.67 501.697L486.95 517.401V548.8Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.229 501.707L486.95 517.401L456.67 501.707V470.309L486.95 454.615L517.229 470.309V501.707Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.95 454.616L456.67 470.31L426.379 454.616V423.217L456.67 407.523L486.95 423.217V454.616Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.229 407.522L486.95 423.216L456.67 407.522V376.124L486.95 360.42L517.229 376.124V407.522Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.95 360.42L456.67 376.124L426.379 360.42V329.032L456.67 313.328L486.95 329.032V360.42Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.229 313.338L486.95 329.032L456.67 313.338V281.94L486.95 266.246L517.229 281.94V313.338Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.95 266.247L456.67 281.941L426.379 266.247V234.849L456.67 219.145L486.95 234.849V266.247Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.229 219.145L486.95 234.849L456.67 219.145V187.757L486.95 172.053L517.229 187.757V219.145Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.95 172.053L456.67 187.757L426.379 172.053V140.655L456.67 124.961L486.95 140.655V172.053Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.229 124.959L486.95 140.653L456.67 124.959V93.5612L486.95 77.8672L517.229 93.5612V124.959Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.95 77.8675L456.67 93.5615L426.379 77.8675V46.4694L456.67 30.7754L486.95 46.4694V77.8675Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.229 30.7757L486.95 46.4799L456.67 30.7757V-0.622436L486.95 -16.3164L517.229 -0.622436V30.7757Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.799 972.627L547.519 988.331L517.229 972.627V941.229L547.519 925.535L577.799 941.229V972.627Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.52 925.535L517.229 941.229L486.949 925.535V894.137L517.229 878.443L547.52 894.137V925.535Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.799 878.444L547.519 894.148L517.229 878.444V847.056L547.519 831.352L577.799 847.056V878.444Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.52 831.352L517.229 847.056L486.949 831.352V799.954L517.229 784.26L547.52 799.954V831.352Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.799 784.26L547.519 799.954L517.229 784.26V752.862L547.519 737.168L577.799 752.862V784.26Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.52 737.168L517.229 752.862L486.949 737.168V705.77L517.229 690.076L547.52 705.77V737.168Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.799 690.076L547.519 705.781L517.229 690.076V658.678L547.519 642.984L577.799 658.678V690.076Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.52 642.983L517.229 658.677L486.949 642.983V611.585L517.229 595.891L547.52 611.585V642.983Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.799 595.891L547.519 611.585L517.229 595.891V564.493L547.519 548.799L577.799 564.493V595.891Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.52 548.8L517.229 564.494L486.949 548.8V517.401L517.229 501.697L547.52 517.401V548.8Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.799 501.707L547.519 517.401L517.229 501.707V470.309L547.519 454.615L577.799 470.309V501.707Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.52 454.616L517.229 470.31L486.949 454.616V423.217L517.229 407.523L547.52 423.217V454.616Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.799 407.522L547.519 423.216L517.229 407.522V376.124L547.519 360.42L577.799 376.124V407.522Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.52 360.42L517.229 376.124L486.949 360.42V329.032L517.229 313.328L547.52 329.032V360.42Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.799 313.338L547.519 329.032L517.229 313.338V281.94L547.519 266.246L577.799 281.94V313.338Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.52 266.247L517.229 281.941L486.949 266.247V234.849L517.229 219.145L547.52 234.849V266.247Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.799 219.145L547.519 234.849L517.229 219.145V187.757L547.519 172.053L577.799 187.757V219.145Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.52 172.053L517.229 187.757L486.949 172.053V140.655L517.229 124.961L547.52 140.655V172.053Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.799 124.959L547.519 140.653L517.229 124.959V93.5612L547.519 77.8672L577.799 93.5612V124.959Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.52 77.8675L517.229 93.5615L486.949 77.8675V46.4694L517.229 30.7754L547.52 46.4694V77.8675Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.799 30.7757L547.519 46.4799L517.229 30.7757V-0.622436L547.519 -16.3164L577.799 -0.622436V30.7757Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.369 972.627L608.078 988.331L577.799 972.627V941.229L608.078 925.535L638.369 941.229V972.627Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.079 925.535L577.799 941.229L547.52 925.535V894.137L577.799 878.443L608.079 894.137V925.535Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.369 878.444L608.078 894.148L577.799 878.444V847.056L608.078 831.352L638.369 847.056V878.444Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.079 831.352L577.799 847.056L547.52 831.352V799.954L577.799 784.26L608.079 799.954V831.352Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.369 784.26L608.078 799.954L577.799 784.26V752.862L608.078 737.168L638.369 752.862V784.26Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.079 737.168L577.799 752.862L547.52 737.168V705.77L577.799 690.076L608.079 705.77V737.168Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.369 690.076L608.078 705.781L577.799 690.076V658.678L608.078 642.984L638.369 658.678V690.076Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.079 642.983L577.799 658.677L547.52 642.983V611.585L577.799 595.891L608.079 611.585V642.983Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.369 595.891L608.078 611.585L577.799 595.891V564.493L608.078 548.799L638.369 564.493V595.891Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.079 548.8L577.799 564.494L547.52 548.8V517.401L577.799 501.697L608.079 517.401V548.8Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.369 501.707L608.078 517.401L577.799 501.707V470.309L608.078 454.615L638.369 470.309V501.707Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.079 454.616L577.799 470.31L547.52 454.616V423.217L577.799 407.523L608.079 423.217V454.616Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.369 407.522L608.078 423.216L577.799 407.522V376.124L608.078 360.42L638.369 376.124V407.522Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.079 360.42L577.799 376.124L547.52 360.42V329.032L577.799 313.328L608.079 329.032V360.42Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.369 313.338L608.078 329.032L577.799 313.338V281.94L608.078 266.246L638.369 281.94V313.338Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.079 266.247L577.799 281.941L547.52 266.247V234.849L577.799 219.145L608.079 234.849V266.247Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.369 219.145L608.078 234.849L577.799 219.145V187.757L608.078 172.053L638.369 187.757V219.145Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.079 172.053L577.799 187.757L547.52 172.053V140.655L577.799 124.961L608.079 140.655V172.053Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.369 124.959L608.078 140.653L577.799 124.959V93.5612L608.078 77.8672L638.369 93.5612V124.959Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.079 77.8675L577.799 93.5615L547.52 77.8675V46.4694L577.799 30.7754L608.079 46.4694V77.8675Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.369 30.7757L608.078 46.4799L577.799 30.7757V-0.622436L608.078 -16.3164L638.369 -0.622436V30.7757Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.928 972.627L668.649 988.331L638.369 972.627V941.229L668.649 925.535L698.928 941.229V972.627Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.649 925.535L638.369 941.229L608.078 925.535V894.137L638.369 878.443L668.649 894.137V925.535Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.928 878.444L668.649 894.148L638.369 878.444V847.056L668.649 831.352L698.928 847.056V878.444Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.649 831.352L638.369 847.056L608.078 831.352V799.954L638.369 784.26L668.649 799.954V831.352Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.928 784.26L668.649 799.954L638.369 784.26V752.862L668.649 737.168L698.928 752.862V784.26Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.649 737.168L638.369 752.862L608.078 737.168V705.77L638.369 690.076L668.649 705.77V737.168Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.928 690.076L668.649 705.781L638.369 690.076V658.678L668.649 642.984L698.928 658.678V690.076Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.649 642.983L638.369 658.677L608.078 642.983V611.585L638.369 595.891L668.649 611.585V642.983Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.928 595.891L668.649 611.585L638.369 595.891V564.493L668.649 548.799L698.928 564.493V595.891Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.649 548.8L638.369 564.494L608.078 548.8V517.401L638.369 501.697L668.649 517.401V548.8Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.928 501.707L668.649 517.401L638.369 501.707V470.309L668.649 454.615L698.928 470.309V501.707Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.649 454.616L638.369 470.31L608.078 454.616V423.217L638.369 407.523L668.649 423.217V454.616Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.928 407.522L668.649 423.216L638.369 407.522V376.124L668.649 360.42L698.928 376.124V407.522Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.649 360.42L638.369 376.124L608.078 360.42V329.032L638.369 313.328L668.649 329.032V360.42Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.928 313.338L668.649 329.032L638.369 313.338V281.94L668.649 266.246L698.928 281.94V313.338Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.649 266.247L638.369 281.941L608.078 266.247V234.849L638.369 219.145L668.649 234.849V266.247Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.928 219.145L668.649 234.849L638.369 219.145V187.757L668.649 172.053L698.928 187.757V219.145Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.649 172.053L638.369 187.757L608.078 172.053V140.655L638.369 124.961L668.649 140.655V172.053Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.928 124.959L668.649 140.653L638.369 124.959V93.5612L668.649 77.8672L698.928 93.5612V124.959Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.649 77.8675L638.369 93.5615L608.078 77.8675V46.4694L638.369 30.7754L668.649 46.4694V77.8675Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.928 30.7757L668.649 46.4799L638.369 30.7757V-0.622436L668.649 -16.3164L698.928 -0.622436V30.7757Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.5 972.627L729.221 988.331L698.93 972.627V941.229L729.221 925.535L759.5 941.229V972.627Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.221 925.535L698.93 941.229L668.65 925.535V894.137L698.93 878.443L729.221 894.137V925.535Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.5 878.444L729.221 894.148L698.93 878.444V847.056L729.221 831.352L759.5 847.056V878.444Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.221 831.352L698.93 847.056L668.65 831.352V799.954L698.93 784.26L729.221 799.954V831.352Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.5 784.26L729.221 799.954L698.93 784.26V752.862L729.221 737.168L759.5 752.862V784.26Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.221 737.168L698.93 752.862L668.65 737.168V705.77L698.93 690.076L729.221 705.77V737.168Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.5 690.076L729.221 705.781L698.93 690.076V658.678L729.221 642.984L759.5 658.678V690.076Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.221 642.983L698.93 658.677L668.65 642.983V611.585L698.93 595.891L729.221 611.585V642.983Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.5 595.891L729.221 611.585L698.93 595.891V564.493L729.221 548.799L759.5 564.493V595.891Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.221 548.8L698.93 564.494L668.65 548.8V517.401L698.93 501.697L729.221 517.401V548.8Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.5 501.707L729.221 517.401L698.93 501.707V470.309L729.221 454.615L759.5 470.309V501.707Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.221 454.616L698.93 470.31L668.65 454.616V423.217L698.93 407.523L729.221 423.217V454.616Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.5 407.522L729.221 423.216L698.93 407.522V376.124L729.221 360.42L759.5 376.124V407.522Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.221 360.42L698.93 376.124L668.65 360.42V329.032L698.93 313.328L729.221 329.032V360.42Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.5 313.338L729.221 329.032L698.93 313.338V281.94L729.221 266.246L759.5 281.94V313.338Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.221 266.247L698.93 281.941L668.65 266.247V234.849L698.93 219.145L729.221 234.849V266.247Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.5 219.145L729.221 234.849L698.93 219.145V187.757L729.221 172.053L759.5 187.757V219.145Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.221 172.053L698.93 187.757L668.65 172.053V140.655L698.93 124.961L729.221 140.655V172.053Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.5 124.959L729.221 140.653L698.93 124.959V93.5612L729.221 77.8672L759.5 93.5612V124.959Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.221 77.8675L698.93 93.5615L668.65 77.8675V46.4694L698.93 30.7754L729.221 46.4694V77.8675Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.5 30.7757L729.221 46.4799L698.93 30.7757V-0.622436L729.221 -16.3164L759.5 -0.622436V30.7757Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.059 972.627L789.78 988.331L759.5 972.627V941.229L789.78 925.535L820.059 941.229V972.627Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.78 925.535L759.5 941.229L729.221 925.535V894.137L759.5 878.443L789.78 894.137V925.535Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.059 878.444L789.78 894.148L759.5 878.444V847.056L789.78 831.352L820.059 847.056V878.444Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.78 831.352L759.5 847.056L729.221 831.352V799.954L759.5 784.26L789.78 799.954V831.352Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.059 784.26L789.78 799.954L759.5 784.26V752.862L789.78 737.168L820.059 752.862V784.26Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.78 737.168L759.5 752.862L729.221 737.168V705.77L759.5 690.076L789.78 705.77V737.168Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.059 690.076L789.78 705.781L759.5 690.076V658.678L789.78 642.984L820.059 658.678V690.076Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.78 642.983L759.5 658.677L729.221 642.983V611.585L759.5 595.891L789.78 611.585V642.983Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.059 595.891L789.78 611.585L759.5 595.891V564.493L789.78 548.799L820.059 564.493V595.891Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.78 548.8L759.5 564.494L729.221 548.8V517.401L759.5 501.697L789.78 517.401V548.8Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.059 501.707L789.78 517.401L759.5 501.707V470.309L789.78 454.615L820.059 470.309V501.707Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.78 454.616L759.5 470.31L729.221 454.616V423.217L759.5 407.523L789.78 423.217V454.616Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.059 407.522L789.78 423.216L759.5 407.522V376.124L789.78 360.42L820.059 376.124V407.522Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.78 360.42L759.5 376.124L729.221 360.42V329.032L759.5 313.328L789.78 329.032V360.42Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.059 313.338L789.78 329.032L759.5 313.338V281.94L789.78 266.246L820.059 281.94V313.338Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.78 266.247L759.5 281.941L729.221 266.247V234.849L759.5 219.145L789.78 234.849V266.247Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.059 219.145L789.78 234.849L759.5 219.145V187.757L789.78 172.053L820.059 187.757V219.145Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.78 172.053L759.5 187.757L729.221 172.053V140.655L759.5 124.961L789.78 140.655V172.053Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.059 124.959L789.78 140.653L759.5 124.959V93.5612L789.78 77.8672L820.059 93.5612V124.959Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.78 77.8675L759.5 93.5615L729.221 77.8675V46.4694L759.5 30.7754L789.78 46.4694V77.8675Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.059 30.7757L789.78 46.4799L759.5 30.7757V-0.622436L789.78 -16.3164L820.059 -0.622436V30.7757Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.698 972.627L2.41831 988.331L-27.8613 972.627V941.229L2.41831 925.535L32.698 941.229V972.627Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.41829 925.535L-27.8613 941.229L-58.1523 925.535V894.137L-27.8613 878.443L2.41829 894.137V925.535Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.698 878.444L2.41831 894.148L-27.8613 878.444V847.056L2.41831 831.352L32.698 847.056V878.444Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.41829 831.352L-27.8613 847.056L-58.1523 831.352V799.954L-27.8613 784.26L2.41829 799.954V831.352Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.698 784.26L2.41831 799.954L-27.8613 784.26V752.862L2.41831 737.168L32.698 752.862V784.26Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.41829 737.168L-27.8613 752.862L-58.1523 737.168V705.77L-27.8613 690.076L2.41829 705.77V737.168Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.698 690.076L2.41831 705.781L-27.8613 690.076V658.678L2.41831 642.984L32.698 658.678V690.076Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.41829 642.983L-27.8613 658.677L-58.1523 642.983V611.585L-27.8613 595.891L2.41829 611.585V642.983Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.698 595.891L2.41831 611.585L-27.8613 595.891V564.493L2.41831 548.799L32.698 564.493V595.891Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.41829 548.8L-27.8613 564.494L-58.1523 548.8V517.401L-27.8613 501.697L2.41829 517.401V548.8Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.698 501.707L2.41831 517.401L-27.8613 501.707V470.309L2.41831 454.615L32.698 470.309V501.707Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.41829 454.616L-27.8613 470.31L-58.1523 454.616V423.217L-27.8613 407.523L2.41829 423.217V454.616Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.698 407.522L2.41831 423.216L-27.8613 407.522V376.124L2.41831 360.42L32.698 376.124V407.522Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.41829 360.42L-27.8613 376.124L-58.1523 360.42V329.032L-27.8613 313.328L2.41829 329.032V360.42Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.698 313.338L2.41831 329.032L-27.8613 313.338V281.94L2.41831 266.246L32.698 281.94V313.338Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.41829 266.247L-27.8613 281.941L-58.1523 266.247V234.849L-27.8613 219.145L2.41829 234.849V266.247Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.698 219.145L2.41831 234.849L-27.8613 219.145V187.757L2.41831 172.053L32.698 187.757V219.145Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.41829 172.053L-27.8613 187.757L-58.1523 172.053V140.655L-27.8613 124.961L2.41829 140.655V172.053Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.698 124.959L2.41831 140.653L-27.8613 124.959V93.5612L2.41831 77.8672L32.698 93.5612V124.959Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.41829 77.8675L-27.8613 93.5615L-58.1523 77.8675V46.4694L-27.8613 30.7754L2.41829 46.4694V77.8675Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.698 30.7757L2.41831 46.4799L-27.8613 30.7757V-0.622436L2.41831 -16.3164L32.698 -0.622436V30.7757Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2679 972.627L62.9883 988.331L32.6973 972.627V941.229L62.9883 925.535L93.2679 941.229V972.627Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9886 925.535L32.6976 941.229L2.41797 925.535V894.137L32.6976 878.443L62.9886 894.137V925.535Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2679 878.444L62.9883 894.148L32.6973 878.444V847.056L62.9883 831.352L93.2679 847.056V878.444Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9886 831.352L32.6976 847.056L2.41797 831.352V799.954L32.6976 784.26L62.9886 799.954V831.352Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2679 784.26L62.9883 799.954L32.6973 784.26V752.862L62.9883 737.168L93.2679 752.862V784.26Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9886 737.168L32.6976 752.862L2.41797 737.168V705.77L32.6976 690.076L62.9886 705.77V737.168Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2679 690.076L62.9883 705.781L32.6973 690.076V658.678L62.9883 642.984L93.2679 658.678V690.076Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9886 642.983L32.6976 658.677L2.41797 642.983V611.585L32.6976 595.891L62.9886 611.585V642.983Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2679 595.891L62.9883 611.585L32.6973 595.891V564.493L62.9883 548.799L93.2679 564.493V595.891Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9886 548.8L32.6976 564.494L2.41797 548.8V517.401L32.6976 501.697L62.9886 517.401V548.8Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2679 501.707L62.9883 517.401L32.6973 501.707V470.309L62.9883 454.615L93.2679 470.309V501.707Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9886 454.616L32.6976 470.31L2.41797 454.616V423.217L32.6976 407.523L62.9886 423.217V454.616Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2679 407.522L62.9883 423.216L32.6973 407.522V376.124L62.9883 360.42L93.2679 376.124V407.522Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9886 360.42L32.6976 376.124L2.41797 360.42V329.032L32.6976 313.328L62.9886 329.032V360.42Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2679 313.338L62.9883 329.032L32.6973 313.338V281.94L62.9883 266.246L93.2679 281.94V313.338Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9886 266.247L32.6976 281.941L2.41797 266.247V234.849L32.6976 219.145L62.9886 234.849V266.247Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2679 219.145L62.9883 234.849L32.6973 219.145V187.757L62.9883 172.053L93.2679 187.757V219.145Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9886 172.053L32.6976 187.757L2.41797 172.053V140.655L32.6976 124.961L62.9886 140.655V172.053Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2679 124.959L62.9883 140.653L32.6973 124.959V93.5612L62.9883 77.8672L93.2679 93.5612V124.959Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9886 77.8675L32.6976 93.5615L2.41797 77.8675V46.4694L32.6976 30.7754L62.9886 46.4694V77.8675Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2679 30.7757L62.9883 46.4799L32.6973 30.7757V-0.622436L62.9883 -16.3164L93.2679 -0.622436V30.7757Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.838 972.627L123.547 988.331L93.2676 972.627V941.229L123.547 925.535L153.838 941.229V972.627Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.548 925.535L93.2679 941.229L62.9883 925.535V894.137L93.2679 878.443L123.548 894.137V925.535Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.838 878.444L123.547 894.148L93.2676 878.444V847.056L123.547 831.352L153.838 847.056V878.444Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.548 831.352L93.2679 847.056L62.9883 831.352V799.954L93.2679 784.26L123.548 799.954V831.352Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.838 784.26L123.547 799.954L93.2676 784.26V752.862L123.547 737.168L153.838 752.862V784.26Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.548 737.168L93.2679 752.862L62.9883 737.168V705.77L93.2679 690.076L123.548 705.77V737.168Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.838 690.076L123.547 705.781L93.2676 690.076V658.678L123.547 642.984L153.838 658.678V690.076Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.548 642.983L93.2679 658.677L62.9883 642.983V611.585L93.2679 595.891L123.548 611.585V642.983Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.838 595.891L123.547 611.585L93.2676 595.891V564.493L123.547 548.799L153.838 564.493V595.891Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.548 548.8L93.2679 564.494L62.9883 548.8V517.401L93.2679 501.697L123.548 517.401V548.8Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.838 501.707L123.547 517.401L93.2676 501.707V470.309L123.547 454.615L153.838 470.309V501.707Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.548 454.616L93.2679 470.31L62.9883 454.616V423.217L93.2679 407.523L123.548 423.217V454.616Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.838 407.522L123.547 423.216L93.2676 407.522V376.124L123.547 360.42L153.838 376.124V407.522Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.548 360.42L93.2679 376.124L62.9883 360.42V329.032L93.2679 313.328L123.548 329.032V360.42Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.838 313.338L123.547 329.032L93.2676 313.338V281.94L123.547 266.246L153.838 281.94V313.338Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.548 266.247L93.2679 281.941L62.9883 266.247V234.849L93.2679 219.145L123.548 234.849V266.247Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.838 219.145L123.547 234.849L93.2676 219.145V187.757L123.547 172.053L153.838 187.757V219.145Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.548 172.053L93.2679 187.757L62.9883 172.053V140.655L93.2679 124.961L123.548 140.655V172.053Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.838 124.959L123.547 140.653L93.2676 124.959V93.5612L123.547 77.8672L153.838 93.5612V124.959Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.548 77.8675L93.2679 93.5615L62.9883 77.8675V46.4694L93.2679 30.7754L123.548 46.4694V77.8675Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.838 30.7757L123.547 46.4799L93.2676 30.7757V-0.622436L123.547 -16.3164L153.838 -0.622436V30.7757Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.399 972.627L184.119 988.331L153.84 972.627V941.229L184.119 925.535L214.399 941.229V972.627Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.119 925.535L153.84 941.229L123.549 925.535V894.137L153.84 878.443L184.119 894.137V925.535Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.399 878.444L184.119 894.148L153.84 878.444V847.056L184.119 831.352L214.399 847.056V878.444Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.119 831.352L153.84 847.056L123.549 831.352V799.954L153.84 784.26L184.119 799.954V831.352Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.399 784.26L184.119 799.954L153.84 784.26V752.862L184.119 737.168L214.399 752.862V784.26Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.119 737.168L153.84 752.862L123.549 737.168V705.77L153.84 690.076L184.119 705.77V737.168Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.399 690.076L184.119 705.781L153.84 690.076V658.678L184.119 642.984L214.399 658.678V690.076Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.119 642.983L153.84 658.677L123.549 642.983V611.585L153.84 595.891L184.119 611.585V642.983Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.399 595.891L184.119 611.585L153.84 595.891V564.493L184.119 548.799L214.399 564.493V595.891Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.119 548.8L153.84 564.494L123.549 548.8V517.401L153.84 501.697L184.119 517.401V548.8Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.399 501.707L184.119 517.401L153.84 501.707V470.309L184.119 454.615L214.399 470.309V501.707Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.119 454.616L153.84 470.31L123.549 454.616V423.217L153.84 407.523L184.119 423.217V454.616Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.399 407.522L184.119 423.216L153.84 407.522V376.124L184.119 360.42L214.399 376.124V407.522Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.119 360.42L153.84 376.124L123.549 360.42V329.032L153.84 313.328L184.119 329.032V360.42Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.399 313.338L184.119 329.032L153.84 313.338V281.94L184.119 266.246L214.399 281.94V313.338Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.119 266.247L153.84 281.941L123.549 266.247V234.849L153.84 219.145L184.119 234.849V266.247Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.399 219.145L184.119 234.849L153.84 219.145V187.757L184.119 172.053L214.399 187.757V219.145Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.119 172.053L153.84 187.757L123.549 172.053V140.655L153.84 124.961L184.119 140.655V172.053Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.399 124.959L184.119 140.653L153.84 124.959V93.5612L184.119 77.8672L214.399 93.5612V124.959Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.119 77.8675L153.84 93.5615L123.549 77.8675V46.4694L153.84 30.7754L184.119 46.4694V77.8675Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.399 30.7757L184.119 46.4799L153.84 30.7757V-0.622436L184.119 -16.3164L214.399 -0.622436V30.7757Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.969 972.627L244.678 988.331L214.398 972.627V941.229L244.678 925.535L274.969 941.229V972.627Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.678 925.535L214.399 941.229L184.119 925.535V894.137L214.399 878.443L244.678 894.137V925.535Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.969 878.444L244.678 894.148L214.398 878.444V847.056L244.678 831.352L274.969 847.056V878.444Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.678 831.352L214.399 847.056L184.119 831.352V799.954L214.399 784.26L244.678 799.954V831.352Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.969 784.26L244.678 799.954L214.398 784.26V752.862L244.678 737.168L274.969 752.862V784.26Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.678 737.168L214.399 752.862L184.119 737.168V705.77L214.399 690.076L244.678 705.77V737.168Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.969 690.076L244.678 705.781L214.398 690.076V658.678L244.678 642.984L274.969 658.678V690.076Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.678 642.983L214.399 658.677L184.119 642.983V611.585L214.399 595.891L244.678 611.585V642.983Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.969 595.891L244.678 611.585L214.398 595.891V564.493L244.678 548.799L274.969 564.493V595.891Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.678 548.8L214.399 564.494L184.119 548.8V517.401L214.399 501.697L244.678 517.401V548.8Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.969 501.707L244.678 517.401L214.398 501.707V470.309L244.678 454.615L274.969 470.309V501.707Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.678 454.616L214.399 470.31L184.119 454.616V423.217L214.399 407.523L244.678 423.217V454.616Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.969 407.522L244.678 423.216L214.398 407.522V376.124L244.678 360.42L274.969 376.124V407.522Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.678 360.42L214.399 376.124L184.119 360.42V329.032L214.399 313.328L244.678 329.032V360.42Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.969 313.338L244.678 329.032L214.398 313.338V281.94L244.678 266.246L274.969 281.94V313.338Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.678 266.247L214.399 281.941L184.119 266.247V234.849L214.399 219.145L244.678 234.849V266.247Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.969 219.145L244.678 234.849L214.398 219.145V187.757L244.678 172.053L274.969 187.757V219.145Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.678 172.053L214.399 187.757L184.119 172.053V140.655L214.399 124.961L244.678 140.655V172.053Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.969 124.959L244.678 140.653L214.398 124.959V93.5612L244.678 77.8672L274.969 93.5612V124.959Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.678 77.8675L214.399 93.5615L184.119 77.8675V46.4694L214.399 30.7754L244.678 46.4694V77.8675Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.969 30.7757L244.678 46.4799L214.398 30.7757V-0.622436L244.678 -16.3164L274.969 -0.622436V30.7757Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.528 972.627L305.248 988.331L274.969 972.627V941.229L305.248 925.535L335.528 941.229V972.627Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.248 925.535L274.969 941.229L244.678 925.535V894.137L274.969 878.443L305.248 894.137V925.535Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.528 878.444L305.248 894.148L274.969 878.444V847.056L305.248 831.352L335.528 847.056V878.444Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.248 831.352L274.969 847.056L244.678 831.352V799.954L274.969 784.26L305.248 799.954V831.352Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.528 784.26L305.248 799.954L274.969 784.26V752.862L305.248 737.168L335.528 752.862V784.26Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.248 737.168L274.969 752.862L244.678 737.168V705.77L274.969 690.076L305.248 705.77V737.168Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.528 690.076L305.248 705.781L274.969 690.076V658.678L305.248 642.984L335.528 658.678V690.076Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.248 642.983L274.969 658.677L244.678 642.983V611.585L274.969 595.891L305.248 611.585V642.983Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.528 595.891L305.248 611.585L274.969 595.891V564.493L305.248 548.799L335.528 564.493V595.891Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.248 548.8L274.969 564.494L244.678 548.8V517.401L274.969 501.697L305.248 517.401V548.8Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.528 501.707L305.248 517.401L274.969 501.707V470.309L305.248 454.615L335.528 470.309V501.707Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.248 454.616L274.969 470.31L244.678 454.616V423.217L274.969 407.523L305.248 423.217V454.616Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.528 407.522L305.248 423.216L274.969 407.522V376.124L305.248 360.42L335.528 376.124V407.522Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.248 360.42L274.969 376.124L244.678 360.42V329.032L274.969 313.328L305.248 329.032V360.42Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.528 313.338L305.248 329.032L274.969 313.338V281.94L305.248 266.246L335.528 281.94V313.338Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.248 266.247L274.969 281.941L244.678 266.247V234.849L274.969 219.145L305.248 234.849V266.247Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.528 219.145L305.248 234.849L274.969 219.145V187.757L305.248 172.053L335.528 187.757V219.145Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.248 172.053L274.969 187.757L244.678 172.053V140.655L274.969 124.961L305.248 140.655V172.053Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.528 124.959L305.248 140.653L274.969 124.959V93.5612L305.248 77.8672L335.528 93.5612V124.959Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.248 77.8675L274.969 93.5615L244.678 77.8675V46.4694L274.969 30.7754L305.248 46.4694V77.8675Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.528 30.7757L305.248 46.4799L274.969 30.7757V-0.622436L305.248 -16.3164L335.528 -0.622436V30.7757Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.098 972.627L365.818 988.331L335.527 972.627V941.229L365.818 925.535L396.098 941.229V972.627Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.819 925.535L335.528 941.229L305.248 925.535V894.137L335.528 878.443L365.819 894.137V925.535Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.098 878.444L365.818 894.148L335.527 878.444V847.056L365.818 831.352L396.098 847.056V878.444Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.819 831.352L335.528 847.056L305.248 831.352V799.954L335.528 784.26L365.819 799.954V831.352Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.098 784.26L365.818 799.954L335.527 784.26V752.862L365.818 737.168L396.098 752.862V784.26Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.819 737.168L335.528 752.862L305.248 737.168V705.77L335.528 690.076L365.819 705.77V737.168Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.098 690.076L365.818 705.781L335.527 690.076V658.678L365.818 642.984L396.098 658.678V690.076Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.819 642.983L335.528 658.677L305.248 642.983V611.585L335.528 595.891L365.819 611.585V642.983Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.098 595.891L365.818 611.585L335.527 595.891V564.493L365.818 548.799L396.098 564.493V595.891Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.819 548.8L335.528 564.494L305.248 548.8V517.401L335.528 501.697L365.819 517.401V548.8Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.098 501.707L365.818 517.401L335.527 501.707V470.309L365.818 454.615L396.098 470.309V501.707Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.819 454.616L335.528 470.31L305.248 454.616V423.217L335.528 407.523L365.819 423.217V454.616Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.098 407.522L365.818 423.216L335.527 407.522V376.124L365.818 360.42L396.098 376.124V407.522Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.819 360.42L335.528 376.124L305.248 360.42V329.032L335.528 313.328L365.819 329.032V360.42Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.098 313.338L365.818 329.032L335.527 313.338V281.94L365.818 266.246L396.098 281.94V313.338Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.819 266.247L335.528 281.941L305.248 266.247V234.849L335.528 219.145L365.819 234.849V266.247Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.098 219.145L365.818 234.849L335.527 219.145V187.757L365.818 172.053L396.098 187.757V219.145Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.819 172.053L335.528 187.757L305.248 172.053V140.655L335.528 124.961L365.819 140.655V172.053Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.098 124.959L365.818 140.653L335.527 124.959V93.5612L365.818 77.8672L396.098 93.5612V124.959Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.819 77.8675L335.528 93.5615L305.248 77.8675V46.4694L335.528 30.7754L365.819 46.4694V77.8675Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.098 30.7757L365.818 46.4799L335.527 30.7757V-0.622436L365.818 -16.3164L396.098 -0.622436V30.7757Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.668 972.627L426.377 988.331L396.098 972.627V941.229L426.377 925.535L456.668 941.229V972.627Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.378 925.535L396.098 941.229L365.818 925.535V894.137L396.098 878.443L426.378 894.137V925.535Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.668 878.444L426.377 894.148L396.098 878.444V847.056L426.377 831.352L456.668 847.056V878.444Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.378 831.352L396.098 847.056L365.818 831.352V799.954L396.098 784.26L426.378 799.954V831.352Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.668 784.26L426.377 799.954L396.098 784.26V752.862L426.377 737.168L456.668 752.862V784.26Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.378 737.168L396.098 752.862L365.818 737.168V705.77L396.098 690.076L426.378 705.77V737.168Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.668 690.076L426.377 705.781L396.098 690.076V658.678L426.377 642.984L456.668 658.678V690.076Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.378 642.983L396.098 658.677L365.818 642.983V611.585L396.098 595.891L426.378 611.585V642.983Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.668 595.891L426.377 611.585L396.098 595.891V564.493L426.377 548.799L456.668 564.493V595.891Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.378 548.8L396.098 564.494L365.818 548.8V517.401L396.098 501.697L426.378 517.401V548.8Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.668 501.707L426.377 517.401L396.098 501.707V470.309L426.377 454.615L456.668 470.309V501.707Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.378 454.616L396.098 470.31L365.818 454.616V423.217L396.098 407.523L426.378 423.217V454.616Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.668 407.522L426.377 423.216L396.098 407.522V376.124L426.377 360.42L456.668 376.124V407.522Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.378 360.42L396.098 376.124L365.818 360.42V329.032L396.098 313.328L426.378 329.032V360.42Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.668 313.338L426.377 329.032L396.098 313.338V281.94L426.377 266.246L456.668 281.94V313.338Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.378 266.247L396.098 281.941L365.818 266.247V234.849L396.098 219.145L426.378 234.849V266.247Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.668 219.145L426.377 234.849L396.098 219.145V187.757L426.377 172.053L456.668 187.757V219.145Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.378 172.053L396.098 187.757L365.818 172.053V140.655L396.098 124.961L426.378 140.655V172.053Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.668 124.959L426.377 140.653L396.098 124.959V93.5612L426.377 77.8672L456.668 93.5612V124.959Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.378 77.8675L396.098 93.5615L365.818 77.8675V46.4694L396.098 30.7754L426.378 46.4694V77.8675Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.668 30.7757L426.377 46.4799L396.098 30.7757V-0.622436L426.377 -16.3164L456.668 -0.622436V30.7757Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_384_21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M517.229 2009.71L486.95 2025.42L456.67 2009.71V1978.32L486.95 1962.62L517.229 1978.32V2009.71Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.95 1962.62L456.67 1978.32L426.379 1962.62V1931.22L456.67 1915.53L486.95 1931.22V1962.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.229 1915.53L486.95 1931.23L456.67 1915.53V1884.14L486.95 1868.44L517.229 1884.14V1915.53Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.95 1868.44L456.67 1884.14L426.379 1868.44V1837.04L456.67 1821.35L486.95 1837.04V1868.44Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.229 1821.35L486.95 1837.04L456.67 1821.35V1789.95L486.95 1774.25L517.229 1789.95V1821.35Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.95 1774.25L456.67 1789.95L426.379 1774.25V1742.86L456.67 1727.16L486.95 1742.86V1774.25Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.229 1727.16L486.95 1742.87L456.67 1727.16V1695.76L486.95 1680.07L517.229 1695.76V1727.16Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.95 1680.07L456.67 1695.76L426.379 1680.07V1648.67L456.67 1632.98L486.95 1648.67V1680.07Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.229 1632.98L486.95 1648.67L456.67 1632.98V1601.58L486.95 1585.88L517.229 1601.58V1632.98Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.95 1585.89L456.67 1601.58L426.379 1585.89V1554.49L456.67 1538.78L486.95 1554.49V1585.89Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.229 1538.79L486.95 1554.49L456.67 1538.79V1507.4L486.95 1491.7L517.229 1507.4V1538.79Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.95 1491.7L456.67 1507.4L426.379 1491.7V1460.3L456.67 1444.61L486.95 1460.3V1491.7Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.229 1444.61L486.95 1460.3L456.67 1444.61V1413.21L486.95 1397.51L517.229 1413.21V1444.61Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.95 1397.51L456.67 1413.21L426.379 1397.51V1366.12L456.67 1350.41L486.95 1366.12V1397.51Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.229 1350.42L486.95 1366.12L456.67 1350.42V1319.03L486.95 1303.33L517.229 1319.03V1350.42Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.95 1303.33L456.67 1319.03L426.379 1303.33V1271.93L456.67 1256.23L486.95 1271.93V1303.33Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.229 1256.23L486.95 1271.93L456.67 1256.23V1224.84L486.95 1209.14L517.229 1224.84V1256.23Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.95 1209.14L456.67 1224.84L426.379 1209.14V1177.74L456.67 1162.05L486.95 1177.74V1209.14Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.229 1162.05L486.95 1177.74L456.67 1162.05V1130.65L486.95 1114.95L517.229 1130.65V1162.05Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.95 1114.95L456.67 1130.65L426.379 1114.95V1083.56L456.67 1067.86L486.95 1083.56V1114.95Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.229 1067.86L486.95 1083.57L456.67 1067.86V1036.46L486.95 1020.77L517.229 1036.46V1067.86Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.95 1020.77L456.67 1036.46L426.379 1020.77V989.372L456.67 973.678L486.95 989.372V1020.77Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.799 2009.71L547.519 2025.42L517.229 2009.71V1978.32L547.519 1962.62L577.799 1978.32V2009.71Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.52 1962.62L517.229 1978.32L486.949 1962.62V1931.22L517.229 1915.53L547.52 1931.22V1962.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.799 1915.53L547.519 1931.23L517.229 1915.53V1884.14L547.519 1868.44L577.799 1884.14V1915.53Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.52 1868.44L517.229 1884.14L486.949 1868.44V1837.04L517.229 1821.35L547.52 1837.04V1868.44Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.799 1821.35L547.519 1837.04L517.229 1821.35V1789.95L547.519 1774.25L577.799 1789.95V1821.35Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.52 1774.25L517.229 1789.95L486.949 1774.25V1742.86L517.229 1727.16L547.52 1742.86V1774.25Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.799 1727.16L547.519 1742.87L517.229 1727.16V1695.76L547.519 1680.07L577.799 1695.76V1727.16Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.52 1680.07L517.229 1695.76L486.949 1680.07V1648.67L517.229 1632.98L547.52 1648.67V1680.07Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.799 1632.98L547.519 1648.67L517.229 1632.98V1601.58L547.519 1585.88L577.799 1601.58V1632.98Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.52 1585.89L517.229 1601.58L486.949 1585.89V1554.49L517.229 1538.78L547.52 1554.49V1585.89Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.799 1538.79L547.519 1554.49L517.229 1538.79V1507.4L547.519 1491.7L577.799 1507.4V1538.79Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.52 1491.7L517.229 1507.4L486.949 1491.7V1460.3L517.229 1444.61L547.52 1460.3V1491.7Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.799 1444.61L547.519 1460.3L517.229 1444.61V1413.21L547.519 1397.51L577.799 1413.21V1444.61Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.52 1397.51L517.229 1413.21L486.949 1397.51V1366.12L517.229 1350.41L547.52 1366.12V1397.51Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.799 1350.42L547.519 1366.12L517.229 1350.42V1319.03L547.519 1303.33L577.799 1319.03V1350.42Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.52 1303.33L517.229 1319.03L486.949 1303.33V1271.93L517.229 1256.23L547.52 1271.93V1303.33Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.799 1256.23L547.519 1271.93L517.229 1256.23V1224.84L547.519 1209.14L577.799 1224.84V1256.23Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.52 1209.14L517.229 1224.84L486.949 1209.14V1177.74L517.229 1162.05L547.52 1177.74V1209.14Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.799 1162.05L547.519 1177.74L517.229 1162.05V1130.65L547.519 1114.95L577.799 1130.65V1162.05Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.52 1114.95L517.229 1130.65L486.949 1114.95V1083.56L517.229 1067.86L547.52 1083.56V1114.95Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.799 1067.86L547.519 1083.57L517.229 1067.86V1036.46L547.519 1020.77L577.799 1036.46V1067.86Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.52 1020.77L517.229 1036.46L486.949 1020.77V989.372L517.229 973.678L547.52 989.372V1020.77Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.369 2009.71L608.078 2025.42L577.799 2009.71V1978.32L608.078 1962.62L638.369 1978.32V2009.71Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.079 1962.62L577.799 1978.32L547.52 1962.62V1931.22L577.799 1915.53L608.079 1931.22V1962.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.369 1915.53L608.078 1931.23L577.799 1915.53V1884.14L608.078 1868.44L638.369 1884.14V1915.53Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.079 1868.44L577.799 1884.14L547.52 1868.44V1837.04L577.799 1821.35L608.079 1837.04V1868.44Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.369 1821.35L608.078 1837.04L577.799 1821.35V1789.95L608.078 1774.25L638.369 1789.95V1821.35Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.079 1774.25L577.799 1789.95L547.52 1774.25V1742.86L577.799 1727.16L608.079 1742.86V1774.25Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.369 1727.16L608.078 1742.87L577.799 1727.16V1695.76L608.078 1680.07L638.369 1695.76V1727.16Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.079 1680.07L577.799 1695.76L547.52 1680.07V1648.67L577.799 1632.98L608.079 1648.67V1680.07Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.369 1632.98L608.078 1648.67L577.799 1632.98V1601.58L608.078 1585.88L638.369 1601.58V1632.98Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.079 1585.89L577.799 1601.58L547.52 1585.89V1554.49L577.799 1538.78L608.079 1554.49V1585.89Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.369 1538.79L608.078 1554.49L577.799 1538.79V1507.4L608.078 1491.7L638.369 1507.4V1538.79Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.079 1491.7L577.799 1507.4L547.52 1491.7V1460.3L577.799 1444.61L608.079 1460.3V1491.7Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.369 1444.61L608.078 1460.3L577.799 1444.61V1413.21L608.078 1397.51L638.369 1413.21V1444.61Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.079 1397.51L577.799 1413.21L547.52 1397.51V1366.12L577.799 1350.41L608.079 1366.12V1397.51Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.369 1350.42L608.078 1366.12L577.799 1350.42V1319.03L608.078 1303.33L638.369 1319.03V1350.42Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.079 1303.33L577.799 1319.03L547.52 1303.33V1271.93L577.799 1256.23L608.079 1271.93V1303.33Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.369 1256.23L608.078 1271.93L577.799 1256.23V1224.84L608.078 1209.14L638.369 1224.84V1256.23Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.079 1209.14L577.799 1224.84L547.52 1209.14V1177.74L577.799 1162.05L608.079 1177.74V1209.14Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.369 1162.05L608.078 1177.74L577.799 1162.05V1130.65L608.078 1114.95L638.369 1130.65V1162.05Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.079 1114.95L577.799 1130.65L547.52 1114.95V1083.56L577.799 1067.86L608.079 1083.56V1114.95Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.369 1067.86L608.078 1083.57L577.799 1067.86V1036.46L608.078 1020.77L638.369 1036.46V1067.86Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.079 1020.77L577.799 1036.46L547.52 1020.77V989.372L577.799 973.678L608.079 989.372V1020.77Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.928 2009.71L668.649 2025.42L638.369 2009.71V1978.32L668.649 1962.62L698.928 1978.32V2009.71Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.649 1962.62L638.369 1978.32L608.078 1962.62V1931.22L638.369 1915.53L668.649 1931.22V1962.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.928 1915.53L668.649 1931.23L638.369 1915.53V1884.14L668.649 1868.44L698.928 1884.14V1915.53Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.649 1868.44L638.369 1884.14L608.078 1868.44V1837.04L638.369 1821.35L668.649 1837.04V1868.44Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.928 1821.35L668.649 1837.04L638.369 1821.35V1789.95L668.649 1774.25L698.928 1789.95V1821.35Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.649 1774.25L638.369 1789.95L608.078 1774.25V1742.86L638.369 1727.16L668.649 1742.86V1774.25Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.928 1727.16L668.649 1742.87L638.369 1727.16V1695.76L668.649 1680.07L698.928 1695.76V1727.16Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.649 1680.07L638.369 1695.76L608.078 1680.07V1648.67L638.369 1632.98L668.649 1648.67V1680.07Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.928 1632.98L668.649 1648.67L638.369 1632.98V1601.58L668.649 1585.88L698.928 1601.58V1632.98Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.649 1585.89L638.369 1601.58L608.078 1585.89V1554.49L638.369 1538.78L668.649 1554.49V1585.89Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.928 1538.79L668.649 1554.49L638.369 1538.79V1507.4L668.649 1491.7L698.928 1507.4V1538.79Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.649 1491.7L638.369 1507.4L608.078 1491.7V1460.3L638.369 1444.61L668.649 1460.3V1491.7Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.928 1444.61L668.649 1460.3L638.369 1444.61V1413.21L668.649 1397.51L698.928 1413.21V1444.61Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.649 1397.51L638.369 1413.21L608.078 1397.51V1366.12L638.369 1350.41L668.649 1366.12V1397.51Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.928 1350.42L668.649 1366.12L638.369 1350.42V1319.03L668.649 1303.33L698.928 1319.03V1350.42Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.649 1303.33L638.369 1319.03L608.078 1303.33V1271.93L638.369 1256.23L668.649 1271.93V1303.33Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.928 1256.23L668.649 1271.93L638.369 1256.23V1224.84L668.649 1209.14L698.928 1224.84V1256.23Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.649 1209.14L638.369 1224.84L608.078 1209.14V1177.74L638.369 1162.05L668.649 1177.74V1209.14Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.928 1162.05L668.649 1177.74L638.369 1162.05V1130.65L668.649 1114.95L698.928 1130.65V1162.05Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.649 1114.95L638.369 1130.65L608.078 1114.95V1083.56L638.369 1067.86L668.649 1083.56V1114.95Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.928 1067.86L668.649 1083.57L638.369 1067.86V1036.46L668.649 1020.77L698.928 1036.46V1067.86Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.649 1020.77L638.369 1036.46L608.078 1020.77V989.372L638.369 973.678L668.649 989.372V1020.77Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.5 2009.71L729.221 2025.42L698.93 2009.71V1978.32L729.221 1962.62L759.5 1978.32V2009.71Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.221 1962.62L698.93 1978.32L668.65 1962.62V1931.22L698.93 1915.53L729.221 1931.22V1962.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.5 1915.53L729.221 1931.23L698.93 1915.53V1884.14L729.221 1868.44L759.5 1884.14V1915.53Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.221 1868.44L698.93 1884.14L668.65 1868.44V1837.04L698.93 1821.35L729.221 1837.04V1868.44Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.5 1821.35L729.221 1837.04L698.93 1821.35V1789.95L729.221 1774.25L759.5 1789.95V1821.35Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.221 1774.25L698.93 1789.95L668.65 1774.25V1742.86L698.93 1727.16L729.221 1742.86V1774.25Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.5 1727.16L729.221 1742.87L698.93 1727.16V1695.76L729.221 1680.07L759.5 1695.76V1727.16Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.221 1680.07L698.93 1695.76L668.65 1680.07V1648.67L698.93 1632.98L729.221 1648.67V1680.07Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.5 1632.98L729.221 1648.67L698.93 1632.98V1601.58L729.221 1585.88L759.5 1601.58V1632.98Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.221 1585.89L698.93 1601.58L668.65 1585.89V1554.49L698.93 1538.78L729.221 1554.49V1585.89Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.5 1538.79L729.221 1554.49L698.93 1538.79V1507.4L729.221 1491.7L759.5 1507.4V1538.79Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.221 1491.7L698.93 1507.4L668.65 1491.7V1460.3L698.93 1444.61L729.221 1460.3V1491.7Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.5 1444.61L729.221 1460.3L698.93 1444.61V1413.21L729.221 1397.51L759.5 1413.21V1444.61Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.221 1397.51L698.93 1413.21L668.65 1397.51V1366.12L698.93 1350.41L729.221 1366.12V1397.51Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.5 1350.42L729.221 1366.12L698.93 1350.42V1319.03L729.221 1303.33L759.5 1319.03V1350.42Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.221 1303.33L698.93 1319.03L668.65 1303.33V1271.93L698.93 1256.23L729.221 1271.93V1303.33Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.5 1256.23L729.221 1271.93L698.93 1256.23V1224.84L729.221 1209.14L759.5 1224.84V1256.23Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.221 1209.14L698.93 1224.84L668.65 1209.14V1177.74L698.93 1162.05L729.221 1177.74V1209.14Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.5 1162.05L729.221 1177.74L698.93 1162.05V1130.65L729.221 1114.95L759.5 1130.65V1162.05Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.221 1114.95L698.93 1130.65L668.65 1114.95V1083.56L698.93 1067.86L729.221 1083.56V1114.95Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.5 1067.86L729.221 1083.57L698.93 1067.86V1036.46L729.221 1020.77L759.5 1036.46V1067.86Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.221 1020.77L698.93 1036.46L668.65 1020.77V989.372L698.93 973.678L729.221 989.372V1020.77Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.059 2009.71L789.78 2025.42L759.5 2009.71V1978.32L789.78 1962.62L820.059 1978.32V2009.71Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.78 1962.62L759.5 1978.32L729.221 1962.62V1931.22L759.5 1915.53L789.78 1931.22V1962.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.059 1915.53L789.78 1931.23L759.5 1915.53V1884.14L789.78 1868.44L820.059 1884.14V1915.53Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.78 1868.44L759.5 1884.14L729.221 1868.44V1837.04L759.5 1821.35L789.78 1837.04V1868.44Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.059 1821.35L789.78 1837.04L759.5 1821.35V1789.95L789.78 1774.25L820.059 1789.95V1821.35Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.78 1774.25L759.5 1789.95L729.221 1774.25V1742.86L759.5 1727.16L789.78 1742.86V1774.25Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.059 1727.16L789.78 1742.87L759.5 1727.16V1695.76L789.78 1680.07L820.059 1695.76V1727.16Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.78 1680.07L759.5 1695.76L729.221 1680.07V1648.67L759.5 1632.98L789.78 1648.67V1680.07Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.059 1632.98L789.78 1648.67L759.5 1632.98V1601.58L789.78 1585.88L820.059 1601.58V1632.98Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.78 1585.89L759.5 1601.58L729.221 1585.89V1554.49L759.5 1538.78L789.78 1554.49V1585.89Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.059 1538.79L789.78 1554.49L759.5 1538.79V1507.4L789.78 1491.7L820.059 1507.4V1538.79Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.78 1491.7L759.5 1507.4L729.221 1491.7V1460.3L759.5 1444.61L789.78 1460.3V1491.7Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.059 1444.61L789.78 1460.3L759.5 1444.61V1413.21L789.78 1397.51L820.059 1413.21V1444.61Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.78 1397.51L759.5 1413.21L729.221 1397.51V1366.12L759.5 1350.41L789.78 1366.12V1397.51Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.059 1350.42L789.78 1366.12L759.5 1350.42V1319.03L789.78 1303.33L820.059 1319.03V1350.42Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.78 1303.33L759.5 1319.03L729.221 1303.33V1271.93L759.5 1256.23L789.78 1271.93V1303.33Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.059 1256.23L789.78 1271.93L759.5 1256.23V1224.84L789.78 1209.14L820.059 1224.84V1256.23Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.78 1209.14L759.5 1224.84L729.221 1209.14V1177.74L759.5 1162.05L789.78 1177.74V1209.14Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.059 1162.05L789.78 1177.74L759.5 1162.05V1130.65L789.78 1114.95L820.059 1130.65V1162.05Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.78 1114.95L759.5 1130.65L729.221 1114.95V1083.56L759.5 1067.86L789.78 1083.56V1114.95Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.059 1067.86L789.78 1083.57L759.5 1067.86V1036.46L789.78 1020.77L820.059 1036.46V1067.86Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.78 1020.77L759.5 1036.46L729.221 1020.77V989.372L759.5 973.678L789.78 989.372V1020.77Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.698 2009.71L2.41831 2025.42L-27.8613 2009.71V1978.32L2.41831 1962.62L32.698 1978.32V2009.71Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.41829 1962.62L-27.8613 1978.32L-58.1523 1962.62V1931.22L-27.8613 1915.53L2.41829 1931.22V1962.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.698 1915.53L2.41831 1931.23L-27.8613 1915.53V1884.14L2.41831 1868.44L32.698 1884.14V1915.53Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.41829 1868.44L-27.8613 1884.14L-58.1523 1868.44V1837.04L-27.8613 1821.35L2.41829 1837.04V1868.44Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.698 1821.35L2.41831 1837.04L-27.8613 1821.35V1789.95L2.41831 1774.25L32.698 1789.95V1821.35Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.41829 1774.25L-27.8613 1789.95L-58.1523 1774.25V1742.86L-27.8613 1727.16L2.41829 1742.86V1774.25Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.698 1727.16L2.41831 1742.87L-27.8613 1727.16V1695.76L2.41831 1680.07L32.698 1695.76V1727.16Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.41829 1680.07L-27.8613 1695.76L-58.1523 1680.07V1648.67L-27.8613 1632.98L2.41829 1648.67V1680.07Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.698 1632.98L2.41831 1648.67L-27.8613 1632.98V1601.58L2.41831 1585.88L32.698 1601.58V1632.98Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.41829 1585.89L-27.8613 1601.58L-58.1523 1585.89V1554.49L-27.8613 1538.78L2.41829 1554.49V1585.89Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.698 1538.79L2.41831 1554.49L-27.8613 1538.79V1507.4L2.41831 1491.7L32.698 1507.4V1538.79Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.41829 1491.7L-27.8613 1507.4L-58.1523 1491.7V1460.3L-27.8613 1444.61L2.41829 1460.3V1491.7Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.698 1444.61L2.41831 1460.3L-27.8613 1444.61V1413.21L2.41831 1397.51L32.698 1413.21V1444.61Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.41829 1397.51L-27.8613 1413.21L-58.1523 1397.51V1366.12L-27.8613 1350.41L2.41829 1366.12V1397.51Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.698 1350.42L2.41831 1366.12L-27.8613 1350.42V1319.03L2.41831 1303.33L32.698 1319.03V1350.42Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.41829 1303.33L-27.8613 1319.03L-58.1523 1303.33V1271.93L-27.8613 1256.23L2.41829 1271.93V1303.33Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.698 1256.23L2.41831 1271.93L-27.8613 1256.23V1224.84L2.41831 1209.14L32.698 1224.84V1256.23Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.41829 1209.14L-27.8613 1224.84L-58.1523 1209.14V1177.74L-27.8613 1162.05L2.41829 1177.74V1209.14Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.698 1162.05L2.41831 1177.74L-27.8613 1162.05V1130.65L2.41831 1114.95L32.698 1130.65V1162.05Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.41829 1114.95L-27.8613 1130.65L-58.1523 1114.95V1083.56L-27.8613 1067.86L2.41829 1083.56V1114.95Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.698 1067.86L2.41831 1083.57L-27.8613 1067.86V1036.46L2.41831 1020.77L32.698 1036.46V1067.86Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.41829 1020.77L-27.8613 1036.46L-58.1523 1020.77V989.372L-27.8613 973.678L2.41829 989.372V1020.77Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2679 2009.71L62.9883 2025.42L32.6973 2009.71V1978.32L62.9883 1962.62L93.2679 1978.32V2009.71Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9886 1962.62L32.6976 1978.32L2.41797 1962.62V1931.22L32.6976 1915.53L62.9886 1931.22V1962.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2679 1915.53L62.9883 1931.23L32.6973 1915.53V1884.14L62.9883 1868.44L93.2679 1884.14V1915.53Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9886 1868.44L32.6976 1884.14L2.41797 1868.44V1837.04L32.6976 1821.35L62.9886 1837.04V1868.44Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2679 1821.35L62.9883 1837.04L32.6973 1821.35V1789.95L62.9883 1774.25L93.2679 1789.95V1821.35Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9886 1774.25L32.6976 1789.95L2.41797 1774.25V1742.86L32.6976 1727.16L62.9886 1742.86V1774.25Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2679 1727.16L62.9883 1742.87L32.6973 1727.16V1695.76L62.9883 1680.07L93.2679 1695.76V1727.16Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9886 1680.07L32.6976 1695.76L2.41797 1680.07V1648.67L32.6976 1632.98L62.9886 1648.67V1680.07Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2679 1632.98L62.9883 1648.67L32.6973 1632.98V1601.58L62.9883 1585.88L93.2679 1601.58V1632.98Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9886 1585.89L32.6976 1601.58L2.41797 1585.89V1554.49L32.6976 1538.78L62.9886 1554.49V1585.89Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2679 1538.79L62.9883 1554.49L32.6973 1538.79V1507.4L62.9883 1491.7L93.2679 1507.4V1538.79Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9886 1491.7L32.6976 1507.4L2.41797 1491.7V1460.3L32.6976 1444.61L62.9886 1460.3V1491.7Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2679 1444.61L62.9883 1460.3L32.6973 1444.61V1413.21L62.9883 1397.51L93.2679 1413.21V1444.61Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9886 1397.51L32.6976 1413.21L2.41797 1397.51V1366.12L32.6976 1350.41L62.9886 1366.12V1397.51Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2679 1350.42L62.9883 1366.12L32.6973 1350.42V1319.03L62.9883 1303.33L93.2679 1319.03V1350.42Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9886 1303.33L32.6976 1319.03L2.41797 1303.33V1271.93L32.6976 1256.23L62.9886 1271.93V1303.33Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2679 1256.23L62.9883 1271.93L32.6973 1256.23V1224.84L62.9883 1209.14L93.2679 1224.84V1256.23Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9886 1209.14L32.6976 1224.84L2.41797 1209.14V1177.74L32.6976 1162.05L62.9886 1177.74V1209.14Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2679 1162.05L62.9883 1177.74L32.6973 1162.05V1130.65L62.9883 1114.95L93.2679 1130.65V1162.05Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9886 1114.95L32.6976 1130.65L2.41797 1114.95V1083.56L32.6976 1067.86L62.9886 1083.56V1114.95Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2679 1067.86L62.9883 1083.57L32.6973 1067.86V1036.46L62.9883 1020.77L93.2679 1036.46V1067.86Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9886 1020.77L32.6976 1036.46L2.41797 1020.77V989.372L32.6976 973.678L62.9886 989.372V1020.77Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.838 2009.71L123.547 2025.42L93.2676 2009.71V1978.32L123.547 1962.62L153.838 1978.32V2009.71Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.548 1962.62L93.2679 1978.32L62.9883 1962.62V1931.22L93.2679 1915.53L123.548 1931.22V1962.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.838 1915.53L123.547 1931.23L93.2676 1915.53V1884.14L123.547 1868.44L153.838 1884.14V1915.53Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.548 1868.44L93.2679 1884.14L62.9883 1868.44V1837.04L93.2679 1821.35L123.548 1837.04V1868.44Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.838 1821.35L123.547 1837.04L93.2676 1821.35V1789.95L123.547 1774.25L153.838 1789.95V1821.35Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.548 1774.25L93.2679 1789.95L62.9883 1774.25V1742.86L93.2679 1727.16L123.548 1742.86V1774.25Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.838 1727.16L123.547 1742.87L93.2676 1727.16V1695.76L123.547 1680.07L153.838 1695.76V1727.16Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.548 1680.07L93.2679 1695.76L62.9883 1680.07V1648.67L93.2679 1632.98L123.548 1648.67V1680.07Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.838 1632.98L123.547 1648.67L93.2676 1632.98V1601.58L123.547 1585.88L153.838 1601.58V1632.98Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.548 1585.89L93.2679 1601.58L62.9883 1585.89V1554.49L93.2679 1538.78L123.548 1554.49V1585.89Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.838 1538.79L123.547 1554.49L93.2676 1538.79V1507.4L123.547 1491.7L153.838 1507.4V1538.79Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.548 1491.7L93.2679 1507.4L62.9883 1491.7V1460.3L93.2679 1444.61L123.548 1460.3V1491.7Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.838 1444.61L123.547 1460.3L93.2676 1444.61V1413.21L123.547 1397.51L153.838 1413.21V1444.61Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.548 1397.51L93.2679 1413.21L62.9883 1397.51V1366.12L93.2679 1350.41L123.548 1366.12V1397.51Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.838 1350.42L123.547 1366.12L93.2676 1350.42V1319.03L123.547 1303.33L153.838 1319.03V1350.42Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.548 1303.33L93.2679 1319.03L62.9883 1303.33V1271.93L93.2679 1256.23L123.548 1271.93V1303.33Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.838 1256.23L123.547 1271.93L93.2676 1256.23V1224.84L123.547 1209.14L153.838 1224.84V1256.23Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.548 1209.14L93.2679 1224.84L62.9883 1209.14V1177.74L93.2679 1162.05L123.548 1177.74V1209.14Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.838 1162.05L123.547 1177.74L93.2676 1162.05V1130.65L123.547 1114.95L153.838 1130.65V1162.05Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.548 1114.95L93.2679 1130.65L62.9883 1114.95V1083.56L93.2679 1067.86L123.548 1083.56V1114.95Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.838 1067.86L123.547 1083.57L93.2676 1067.86V1036.46L123.547 1020.77L153.838 1036.46V1067.86Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.548 1020.77L93.2679 1036.46L62.9883 1020.77V989.372L93.2679 973.678L123.548 989.372V1020.77Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.399 2009.71L184.119 2025.42L153.84 2009.71V1978.32L184.119 1962.62L214.399 1978.32V2009.71Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.119 1962.62L153.84 1978.32L123.549 1962.62V1931.22L153.84 1915.53L184.119 1931.22V1962.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.399 1915.53L184.119 1931.23L153.84 1915.53V1884.14L184.119 1868.44L214.399 1884.14V1915.53Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.119 1868.44L153.84 1884.14L123.549 1868.44V1837.04L153.84 1821.35L184.119 1837.04V1868.44Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.399 1821.35L184.119 1837.04L153.84 1821.35V1789.95L184.119 1774.25L214.399 1789.95V1821.35Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.119 1774.25L153.84 1789.95L123.549 1774.25V1742.86L153.84 1727.16L184.119 1742.86V1774.25Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.399 1727.16L184.119 1742.87L153.84 1727.16V1695.76L184.119 1680.07L214.399 1695.76V1727.16Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.119 1680.07L153.84 1695.76L123.549 1680.07V1648.67L153.84 1632.98L184.119 1648.67V1680.07Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.399 1632.98L184.119 1648.67L153.84 1632.98V1601.58L184.119 1585.88L214.399 1601.58V1632.98Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.119 1585.89L153.84 1601.58L123.549 1585.89V1554.49L153.84 1538.78L184.119 1554.49V1585.89Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.399 1538.79L184.119 1554.49L153.84 1538.79V1507.4L184.119 1491.7L214.399 1507.4V1538.79Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.119 1491.7L153.84 1507.4L123.549 1491.7V1460.3L153.84 1444.61L184.119 1460.3V1491.7Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.399 1444.61L184.119 1460.3L153.84 1444.61V1413.21L184.119 1397.51L214.399 1413.21V1444.61Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.119 1397.51L153.84 1413.21L123.549 1397.51V1366.12L153.84 1350.41L184.119 1366.12V1397.51Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.399 1350.42L184.119 1366.12L153.84 1350.42V1319.03L184.119 1303.33L214.399 1319.03V1350.42Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.119 1303.33L153.84 1319.03L123.549 1303.33V1271.93L153.84 1256.23L184.119 1271.93V1303.33Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.399 1256.23L184.119 1271.93L153.84 1256.23V1224.84L184.119 1209.14L214.399 1224.84V1256.23Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.119 1209.14L153.84 1224.84L123.549 1209.14V1177.74L153.84 1162.05L184.119 1177.74V1209.14Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.399 1162.05L184.119 1177.74L153.84 1162.05V1130.65L184.119 1114.95L214.399 1130.65V1162.05Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.119 1114.95L153.84 1130.65L123.549 1114.95V1083.56L153.84 1067.86L184.119 1083.56V1114.95Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.399 1067.86L184.119 1083.57L153.84 1067.86V1036.46L184.119 1020.77L214.399 1036.46V1067.86Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.119 1020.77L153.84 1036.46L123.549 1020.77V989.372L153.84 973.678L184.119 989.372V1020.77Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.969 2009.71L244.678 2025.42L214.398 2009.71V1978.32L244.678 1962.62L274.969 1978.32V2009.71Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.678 1962.62L214.399 1978.32L184.119 1962.62V1931.22L214.399 1915.53L244.678 1931.22V1962.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.969 1915.53L244.678 1931.23L214.398 1915.53V1884.14L244.678 1868.44L274.969 1884.14V1915.53Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.678 1868.44L214.399 1884.14L184.119 1868.44V1837.04L214.399 1821.35L244.678 1837.04V1868.44Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.969 1821.35L244.678 1837.04L214.398 1821.35V1789.95L244.678 1774.25L274.969 1789.95V1821.35Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.678 1774.25L214.399 1789.95L184.119 1774.25V1742.86L214.399 1727.16L244.678 1742.86V1774.25Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.969 1727.16L244.678 1742.87L214.398 1727.16V1695.76L244.678 1680.07L274.969 1695.76V1727.16Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.678 1680.07L214.399 1695.76L184.119 1680.07V1648.67L214.399 1632.98L244.678 1648.67V1680.07Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.969 1632.98L244.678 1648.67L214.398 1632.98V1601.58L244.678 1585.88L274.969 1601.58V1632.98Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.678 1585.89L214.399 1601.58L184.119 1585.89V1554.49L214.399 1538.78L244.678 1554.49V1585.89Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.969 1538.79L244.678 1554.49L214.398 1538.79V1507.4L244.678 1491.7L274.969 1507.4V1538.79Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.678 1491.7L214.399 1507.4L184.119 1491.7V1460.3L214.399 1444.61L244.678 1460.3V1491.7Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.969 1444.61L244.678 1460.3L214.398 1444.61V1413.21L244.678 1397.51L274.969 1413.21V1444.61Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.678 1397.51L214.399 1413.21L184.119 1397.51V1366.12L214.399 1350.41L244.678 1366.12V1397.51Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.969 1350.42L244.678 1366.12L214.398 1350.42V1319.03L244.678 1303.33L274.969 1319.03V1350.42Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.678 1303.33L214.399 1319.03L184.119 1303.33V1271.93L214.399 1256.23L244.678 1271.93V1303.33Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.969 1256.23L244.678 1271.93L214.398 1256.23V1224.84L244.678 1209.14L274.969 1224.84V1256.23Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.678 1209.14L214.399 1224.84L184.119 1209.14V1177.74L214.399 1162.05L244.678 1177.74V1209.14Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.969 1162.05L244.678 1177.74L214.398 1162.05V1130.65L244.678 1114.95L274.969 1130.65V1162.05Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.678 1114.95L214.399 1130.65L184.119 1114.95V1083.56L214.399 1067.86L244.678 1083.56V1114.95Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.969 1067.86L244.678 1083.57L214.398 1067.86V1036.46L244.678 1020.77L274.969 1036.46V1067.86Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.678 1020.77L214.399 1036.46L184.119 1020.77V989.372L214.399 973.678L244.678 989.372V1020.77Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.528 2009.71L305.248 2025.42L274.969 2009.71V1978.32L305.248 1962.62L335.528 1978.32V2009.71Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.248 1962.62L274.969 1978.32L244.678 1962.62V1931.22L274.969 1915.53L305.248 1931.22V1962.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.528 1915.53L305.248 1931.23L274.969 1915.53V1884.14L305.248 1868.44L335.528 1884.14V1915.53Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.248 1868.44L274.969 1884.14L244.678 1868.44V1837.04L274.969 1821.35L305.248 1837.04V1868.44Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.528 1821.35L305.248 1837.04L274.969 1821.35V1789.95L305.248 1774.25L335.528 1789.95V1821.35Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.248 1774.25L274.969 1789.95L244.678 1774.25V1742.86L274.969 1727.16L305.248 1742.86V1774.25Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.528 1727.16L305.248 1742.87L274.969 1727.16V1695.76L305.248 1680.07L335.528 1695.76V1727.16Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.248 1680.07L274.969 1695.76L244.678 1680.07V1648.67L274.969 1632.98L305.248 1648.67V1680.07Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.528 1632.98L305.248 1648.67L274.969 1632.98V1601.58L305.248 1585.88L335.528 1601.58V1632.98Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.248 1585.89L274.969 1601.58L244.678 1585.89V1554.49L274.969 1538.78L305.248 1554.49V1585.89Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.528 1538.79L305.248 1554.49L274.969 1538.79V1507.4L305.248 1491.7L335.528 1507.4V1538.79Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.248 1491.7L274.969 1507.4L244.678 1491.7V1460.3L274.969 1444.61L305.248 1460.3V1491.7Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.528 1444.61L305.248 1460.3L274.969 1444.61V1413.21L305.248 1397.51L335.528 1413.21V1444.61Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.248 1397.51L274.969 1413.21L244.678 1397.51V1366.12L274.969 1350.41L305.248 1366.12V1397.51Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.528 1350.42L305.248 1366.12L274.969 1350.42V1319.03L305.248 1303.33L335.528 1319.03V1350.42Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.248 1303.33L274.969 1319.03L244.678 1303.33V1271.93L274.969 1256.23L305.248 1271.93V1303.33Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.528 1256.23L305.248 1271.93L274.969 1256.23V1224.84L305.248 1209.14L335.528 1224.84V1256.23Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.248 1209.14L274.969 1224.84L244.678 1209.14V1177.74L274.969 1162.05L305.248 1177.74V1209.14Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.528 1162.05L305.248 1177.74L274.969 1162.05V1130.65L305.248 1114.95L335.528 1130.65V1162.05Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.248 1114.95L274.969 1130.65L244.678 1114.95V1083.56L274.969 1067.86L305.248 1083.56V1114.95Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.528 1067.86L305.248 1083.57L274.969 1067.86V1036.46L305.248 1020.77L335.528 1036.46V1067.86Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.248 1020.77L274.969 1036.46L244.678 1020.77V989.372L274.969 973.678L305.248 989.372V1020.77Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.098 2009.71L365.818 2025.42L335.527 2009.71V1978.32L365.818 1962.62L396.098 1978.32V2009.71Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.819 1962.62L335.528 1978.32L305.248 1962.62V1931.22L335.528 1915.53L365.819 1931.22V1962.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.098 1915.53L365.818 1931.23L335.527 1915.53V1884.14L365.818 1868.44L396.098 1884.14V1915.53Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.819 1868.44L335.528 1884.14L305.248 1868.44V1837.04L335.528 1821.35L365.819 1837.04V1868.44Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.098 1821.35L365.818 1837.04L335.527 1821.35V1789.95L365.818 1774.25L396.098 1789.95V1821.35Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.819 1774.25L335.528 1789.95L305.248 1774.25V1742.86L335.528 1727.16L365.819 1742.86V1774.25Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.098 1727.16L365.818 1742.87L335.527 1727.16V1695.76L365.818 1680.07L396.098 1695.76V1727.16Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.819 1680.07L335.528 1695.76L305.248 1680.07V1648.67L335.528 1632.98L365.819 1648.67V1680.07Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.098 1632.98L365.818 1648.67L335.527 1632.98V1601.58L365.818 1585.88L396.098 1601.58V1632.98Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.819 1585.89L335.528 1601.58L305.248 1585.89V1554.49L335.528 1538.78L365.819 1554.49V1585.89Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.098 1538.79L365.818 1554.49L335.527 1538.79V1507.4L365.818 1491.7L396.098 1507.4V1538.79Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.819 1491.7L335.528 1507.4L305.248 1491.7V1460.3L335.528 1444.61L365.819 1460.3V1491.7Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.098 1444.61L365.818 1460.3L335.527 1444.61V1413.21L365.818 1397.51L396.098 1413.21V1444.61Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.819 1397.51L335.528 1413.21L305.248 1397.51V1366.12L335.528 1350.41L365.819 1366.12V1397.51Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.098 1350.42L365.818 1366.12L335.527 1350.42V1319.03L365.818 1303.33L396.098 1319.03V1350.42Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.819 1303.33L335.528 1319.03L305.248 1303.33V1271.93L335.528 1256.23L365.819 1271.93V1303.33Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.098 1256.23L365.818 1271.93L335.527 1256.23V1224.84L365.818 1209.14L396.098 1224.84V1256.23Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.819 1209.14L335.528 1224.84L305.248 1209.14V1177.74L335.528 1162.05L365.819 1177.74V1209.14Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.098 1162.05L365.818 1177.74L335.527 1162.05V1130.65L365.818 1114.95L396.098 1130.65V1162.05Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.819 1114.95L335.528 1130.65L305.248 1114.95V1083.56L335.528 1067.86L365.819 1083.56V1114.95Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.098 1067.86L365.818 1083.57L335.527 1067.86V1036.46L365.818 1020.77L396.098 1036.46V1067.86Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.819 1020.77L335.528 1036.46L305.248 1020.77V989.372L335.528 973.678L365.819 989.372V1020.77Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.668 2009.71L426.377 2025.42L396.098 2009.71V1978.32L426.377 1962.62L456.668 1978.32V2009.71Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.378 1962.62L396.098 1978.32L365.818 1962.62V1931.22L396.098 1915.53L426.378 1931.22V1962.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.668 1915.53L426.377 1931.23L396.098 1915.53V1884.14L426.377 1868.44L456.668 1884.14V1915.53Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.378 1868.44L396.098 1884.14L365.818 1868.44V1837.04L396.098 1821.35L426.378 1837.04V1868.44Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.668 1821.35L426.377 1837.04L396.098 1821.35V1789.95L426.377 1774.25L456.668 1789.95V1821.35Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.378 1774.25L396.098 1789.95L365.818 1774.25V1742.86L396.098 1727.16L426.378 1742.86V1774.25Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.668 1727.16L426.377 1742.87L396.098 1727.16V1695.76L426.377 1680.07L456.668 1695.76V1727.16Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.378 1680.07L396.098 1695.76L365.818 1680.07V1648.67L396.098 1632.98L426.378 1648.67V1680.07Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.668 1632.98L426.377 1648.67L396.098 1632.98V1601.58L426.377 1585.88L456.668 1601.58V1632.98Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.378 1585.89L396.098 1601.58L365.818 1585.89V1554.49L396.098 1538.78L426.378 1554.49V1585.89Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.668 1538.79L426.377 1554.49L396.098 1538.79V1507.4L426.377 1491.7L456.668 1507.4V1538.79Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.378 1491.7L396.098 1507.4L365.818 1491.7V1460.3L396.098 1444.61L426.378 1460.3V1491.7Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.668 1444.61L426.377 1460.3L396.098 1444.61V1413.21L426.377 1397.51L456.668 1413.21V1444.61Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.378 1397.51L396.098 1413.21L365.818 1397.51V1366.12L396.098 1350.41L426.378 1366.12V1397.51Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.668 1350.42L426.377 1366.12L396.098 1350.42V1319.03L426.377 1303.33L456.668 1319.03V1350.42Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.378 1303.33L396.098 1319.03L365.818 1303.33V1271.93L396.098 1256.23L426.378 1271.93V1303.33Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.668 1256.23L426.377 1271.93L396.098 1256.23V1224.84L426.377 1209.14L456.668 1224.84V1256.23Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.378 1209.14L396.098 1224.84L365.818 1209.14V1177.74L396.098 1162.05L426.378 1177.74V1209.14Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.668 1162.05L426.377 1177.74L396.098 1162.05V1130.65L426.377 1114.95L456.668 1130.65V1162.05Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.378 1114.95L396.098 1130.65L365.818 1114.95V1083.56L396.098 1067.86L426.378 1083.56V1114.95Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.668 1067.86L426.377 1083.57L396.098 1067.86V1036.46L426.377 1020.77L456.668 1036.46V1067.86Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.378 1020.77L396.098 1036.46L365.818 1020.77V989.372L396.098 973.678L426.378 989.372V1020.77Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 720.832,
    cy: 2216.62,
    rx: 190.49,
    ry: 218.423,
    fill: "url(#paint4_radial_384_21)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.9488,
    cy: 1891.42,
    rx: 190.49,
    ry: 218.423,
    fill: "url(#paint5_radial_384_21)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.95 2295.62L497.67 2311.31L467.379 2295.62V2264.22L497.67 2248.52L527.95 2264.22V2295.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.229 2248.52L527.95 2264.22L497.67 2248.52V2217.12L527.95 2201.42L558.229 2217.12V2248.52Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.95 2201.42L497.67 2217.12L467.379 2201.42V2170.03L497.67 2154.33L527.95 2170.03V2201.42Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.229 2154.34L527.95 2170.03L497.67 2154.34V2122.94L527.95 2107.25L558.229 2122.94V2154.34Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.95 2107.25L497.67 2122.94L467.379 2107.25V2075.85L497.67 2060.14L527.95 2075.85V2107.25Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.229 2060.14L527.95 2075.85L497.67 2060.14V2028.76L527.95 2013.05L558.229 2028.76V2060.14Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.95 2013.05L497.67 2028.76L467.379 2013.05V1981.65L497.67 1965.96L527.95 1981.65V2013.05Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.229 1965.96L527.95 1981.65L497.67 1965.96V1934.56L527.95 1918.87L558.229 1934.56V1965.96Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.95 1918.87L497.67 1934.56L467.379 1918.87V1887.47L497.67 1871.78L527.95 1887.47V1918.87Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.229 1871.78L527.95 1887.48L497.67 1871.78V1840.38L527.95 1824.68L558.229 1840.38V1871.78Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.95 1824.68L497.67 1840.38L467.379 1824.68V1793.29L497.67 1777.59L527.95 1793.29V1824.68Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.52 2295.62L558.229 2311.31L527.949 2295.62V2264.22L558.229 2248.52L588.52 2264.22V2295.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.799 2248.52L588.519 2264.22L558.229 2248.52V2217.12L588.519 2201.42L618.799 2217.12V2248.52Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.52 2201.42L558.229 2217.12L527.949 2201.42V2170.03L558.229 2154.33L588.52 2170.03V2201.42Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.799 2154.34L588.519 2170.03L558.229 2154.34V2122.94L588.519 2107.25L618.799 2122.94V2154.34Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.52 2107.25L558.229 2122.94L527.949 2107.25V2075.85L558.229 2060.14L588.52 2075.85V2107.25Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.799 2060.14L588.519 2075.85L558.229 2060.14V2028.76L588.519 2013.05L618.799 2028.76V2060.14Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.52 2013.05L558.229 2028.76L527.949 2013.05V1981.65L558.229 1965.96L588.52 1981.65V2013.05Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.799 1965.96L588.519 1981.65L558.229 1965.96V1934.56L588.519 1918.87L618.799 1934.56V1965.96Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.52 1918.87L558.229 1934.56L527.949 1918.87V1887.47L558.229 1871.78L588.52 1887.47V1918.87Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.799 1871.78L588.519 1887.48L558.229 1871.78V1840.38L588.519 1824.68L618.799 1840.38V1871.78Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.52 1824.68L558.229 1840.38L527.949 1824.68V1793.29L558.229 1777.59L588.52 1793.29V1824.68Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.079 2295.62L618.799 2311.31L588.52 2295.62V2264.22L618.799 2248.52L649.079 2264.22V2295.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.369 2248.52L649.078 2264.22L618.799 2248.52V2217.12L649.078 2201.42L679.369 2217.12V2248.52Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.079 2201.42L618.799 2217.12L588.52 2201.42V2170.03L618.799 2154.33L649.079 2170.03V2201.42Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.369 2154.34L649.078 2170.03L618.799 2154.34V2122.94L649.078 2107.25L679.369 2122.94V2154.34Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.079 2107.25L618.799 2122.94L588.52 2107.25V2075.85L618.799 2060.14L649.079 2075.85V2107.25Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.369 2060.14L649.078 2075.85L618.799 2060.14V2028.76L649.078 2013.05L679.369 2028.76V2060.14Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.079 2013.05L618.799 2028.76L588.52 2013.05V1981.65L618.799 1965.96L649.079 1981.65V2013.05Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.369 1965.96L649.078 1981.65L618.799 1965.96V1934.56L649.078 1918.87L679.369 1934.56V1965.96Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.079 1918.87L618.799 1934.56L588.52 1918.87V1887.47L618.799 1871.78L649.079 1887.47V1918.87Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.369 1871.78L649.078 1887.48L618.799 1871.78V1840.38L649.078 1824.68L679.369 1840.38V1871.78Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.079 1824.68L618.799 1840.38L588.52 1824.68V1793.29L618.799 1777.59L649.079 1793.29V1824.68Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.649 2295.62L679.369 2311.31L649.078 2295.62V2264.22L679.369 2248.52L709.649 2264.22V2295.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.928 2248.52L709.649 2264.22L679.369 2248.52V2217.12L709.649 2201.42L739.928 2217.12V2248.52Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.649 2201.42L679.369 2217.12L649.078 2201.42V2170.03L679.369 2154.33L709.649 2170.03V2201.42Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.928 2154.34L709.649 2170.03L679.369 2154.34V2122.94L709.649 2107.25L739.928 2122.94V2154.34Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.649 2107.25L679.369 2122.94L649.078 2107.25V2075.85L679.369 2060.14L709.649 2075.85V2107.25Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.928 2060.14L709.649 2075.85L679.369 2060.14V2028.76L709.649 2013.05L739.928 2028.76V2060.14Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.649 2013.05L679.369 2028.76L649.078 2013.05V1981.65L679.369 1965.96L709.649 1981.65V2013.05Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.928 1965.96L709.649 1981.65L679.369 1965.96V1934.56L709.649 1918.87L739.928 1934.56V1965.96Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.649 1918.87L679.369 1934.56L649.078 1918.87V1887.47L679.369 1871.78L709.649 1887.47V1918.87Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.928 1871.78L709.649 1887.48L679.369 1871.78V1840.38L709.649 1824.68L739.928 1840.38V1871.78Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.649 1824.68L679.369 1840.38L649.078 1824.68V1793.29L679.369 1777.59L709.649 1793.29V1824.68Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.221 2295.62L739.93 2311.31L709.65 2295.62V2264.22L739.93 2248.52L770.221 2264.22V2295.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.5 2248.52L770.221 2264.22L739.93 2248.52V2217.12L770.221 2201.42L800.5 2217.12V2248.52Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.221 2201.42L739.93 2217.12L709.65 2201.42V2170.03L739.93 2154.33L770.221 2170.03V2201.42Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.5 2154.34L770.221 2170.03L739.93 2154.34V2122.94L770.221 2107.25L800.5 2122.94V2154.34Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.221 2107.25L739.93 2122.94L709.65 2107.25V2075.85L739.93 2060.14L770.221 2075.85V2107.25Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.5 2060.14L770.221 2075.85L739.93 2060.14V2028.76L770.221 2013.05L800.5 2028.76V2060.14Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.221 2013.05L739.93 2028.76L709.65 2013.05V1981.65L739.93 1965.96L770.221 1981.65V2013.05Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.5 1965.96L770.221 1981.65L739.93 1965.96V1934.56L770.221 1918.87L800.5 1934.56V1965.96Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.221 1918.87L739.93 1934.56L709.65 1918.87V1887.47L739.93 1871.78L770.221 1887.47V1918.87Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.5 1871.78L770.221 1887.48L739.93 1871.78V1840.38L770.221 1824.68L800.5 1840.38V1871.78Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.221 1824.68L739.93 1840.38L709.65 1824.68V1793.29L739.93 1777.59L770.221 1793.29V1824.68Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.139 2248.52L-17.152 2264.22L-47.4316 2248.52V2217.12L-17.152 2201.42L13.139 2217.12V2248.52Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.139 2154.34L-17.152 2170.03L-47.4316 2154.34V2122.94L-17.152 2107.25L13.139 2122.94V2154.34Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.139 2060.14L-17.152 2075.85L-47.4316 2060.14V2028.76L-17.152 2013.05L13.139 2028.76V2060.14Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.139 1965.96L-17.152 1981.65L-47.4316 1965.96V1934.56L-17.152 1918.87L13.139 1934.56V1965.96Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.139 1871.78L-17.152 1887.48L-47.4316 1871.78V1840.38L-17.152 1824.68L13.139 1840.38V1871.78Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4183 2295.62L13.1387 2311.31L-17.1523 2295.62V2264.22L13.1387 2248.52L43.4183 2264.22V2295.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.698 2248.52L43.4183 2264.22L13.1387 2248.52V2217.12L43.4183 2201.42L73.698 2217.12V2248.52Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4183 2201.42L13.1387 2217.12L-17.1523 2201.42V2170.03L13.1387 2154.33L43.4183 2170.03V2201.42Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.698 2154.34L43.4183 2170.03L13.1387 2154.34V2122.94L43.4183 2107.25L73.698 2122.94V2154.34Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4183 2107.25L13.1387 2122.94L-17.1523 2107.25V2075.85L13.1387 2060.14L43.4183 2075.85V2107.25Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.698 2060.14L43.4183 2075.85L13.1387 2060.14V2028.76L43.4183 2013.05L73.698 2028.76V2060.14Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4183 2013.05L13.1387 2028.76L-17.1523 2013.05V1981.65L13.1387 1965.96L43.4183 1981.65V2013.05Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.698 1965.96L43.4183 1981.65L13.1387 1965.96V1934.56L43.4183 1918.87L73.698 1934.56V1965.96Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4183 1918.87L13.1387 1934.56L-17.1523 1918.87V1887.47L13.1387 1871.78L43.4183 1887.47V1918.87Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.698 1871.78L43.4183 1887.48L13.1387 1871.78V1840.38L43.4183 1824.68L73.698 1840.38V1871.78Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4183 1824.68L13.1387 1840.38L-17.1523 1824.68V1793.29L13.1387 1777.59L43.4183 1793.29V1824.68Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.989 2295.62L73.6976 2311.31L43.418 2295.62V2264.22L73.6976 2248.52L103.989 2264.22V2295.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.268 2248.52L103.988 2264.22L73.6973 2248.52V2217.12L103.988 2201.42L134.268 2217.12V2248.52Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.989 2201.42L73.6976 2217.12L43.418 2201.42V2170.03L73.6976 2154.33L103.989 2170.03V2201.42Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.268 2154.34L103.988 2170.03L73.6973 2154.34V2122.94L103.988 2107.25L134.268 2122.94V2154.34Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.989 2107.25L73.6976 2122.94L43.418 2107.25V2075.85L73.6976 2060.14L103.989 2075.85V2107.25Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.268 2060.14L103.988 2075.85L73.6973 2060.14V2028.76L103.988 2013.05L134.268 2028.76V2060.14Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.989 2013.05L73.6976 2028.76L43.418 2013.05V1981.65L73.6976 1965.96L103.989 1981.65V2013.05Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.268 1965.96L103.988 1981.65L73.6973 1965.96V1934.56L103.988 1918.87L134.268 1934.56V1965.96Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.989 1918.87L73.6976 1934.56L43.418 1918.87V1887.47L73.6976 1871.78L103.989 1887.47V1918.87Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.268 1871.78L103.988 1887.48L73.6973 1871.78V1840.38L103.988 1824.68L134.268 1840.38V1871.78Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.989 1824.68L73.6976 1840.38L43.418 1824.68V1793.29L73.6976 1777.59L103.989 1793.29V1824.68Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.548 2295.62L134.268 2311.31L103.988 2295.62V2264.22L134.268 2248.52L164.548 2264.22V2295.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.838 2248.52L164.547 2264.22L134.268 2248.52V2217.12L164.547 2201.42L194.838 2217.12V2248.52Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.548 2201.42L134.268 2217.12L103.988 2201.42V2170.03L134.268 2154.33L164.548 2170.03V2201.42Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.838 2154.34L164.547 2170.03L134.268 2154.34V2122.94L164.547 2107.25L194.838 2122.94V2154.34Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.548 2107.25L134.268 2122.94L103.988 2107.25V2075.85L134.268 2060.14L164.548 2075.85V2107.25Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.838 2060.14L164.547 2075.85L134.268 2060.14V2028.76L164.547 2013.05L194.838 2028.76V2060.14Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.548 2013.05L134.268 2028.76L103.988 2013.05V1981.65L134.268 1965.96L164.548 1981.65V2013.05Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.838 1965.96L164.547 1981.65L134.268 1965.96V1934.56L164.547 1918.87L194.838 1934.56V1965.96Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.548 1918.87L134.268 1934.56L103.988 1918.87V1887.47L134.268 1871.78L164.548 1887.47V1918.87Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.838 1871.78L164.547 1887.48L134.268 1871.78V1840.38L164.547 1824.68L194.838 1840.38V1871.78Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.548 1824.68L134.268 1840.38L103.988 1824.68V1793.29L134.268 1777.59L164.548 1793.29V1824.68Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.119 2295.62L194.84 2311.31L164.549 2295.62V2264.22L194.84 2248.52L225.119 2264.22V2295.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.399 2248.52L225.119 2264.22L194.84 2248.52V2217.12L225.119 2201.42L255.399 2217.12V2248.52Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.119 2201.42L194.84 2217.12L164.549 2201.42V2170.03L194.84 2154.33L225.119 2170.03V2201.42Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.399 2154.34L225.119 2170.03L194.84 2154.34V2122.94L225.119 2107.25L255.399 2122.94V2154.34Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.119 2107.25L194.84 2122.94L164.549 2107.25V2075.85L194.84 2060.14L225.119 2075.85V2107.25Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.399 2060.14L225.119 2075.85L194.84 2060.14V2028.76L225.119 2013.05L255.399 2028.76V2060.14Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.119 2013.05L194.84 2028.76L164.549 2013.05V1981.65L194.84 1965.96L225.119 1981.65V2013.05Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.399 1965.96L225.119 1981.65L194.84 1965.96V1934.56L225.119 1918.87L255.399 1934.56V1965.96Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.119 1918.87L194.84 1934.56L164.549 1918.87V1887.47L194.84 1871.78L225.119 1887.47V1918.87Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.399 1871.78L225.119 1887.48L194.84 1871.78V1840.38L225.119 1824.68L255.399 1840.38V1871.78Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.119 1824.68L194.84 1840.38L164.549 1824.68V1793.29L194.84 1777.59L225.119 1793.29V1824.68Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.678 2295.62L255.399 2311.31L225.119 2295.62V2264.22L255.399 2248.52L285.678 2264.22V2295.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.969 2248.52L285.678 2264.22L255.398 2248.52V2217.12L285.678 2201.42L315.969 2217.12V2248.52Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.678 2201.42L255.399 2217.12L225.119 2201.42V2170.03L255.399 2154.33L285.678 2170.03V2201.42Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.969 2154.34L285.678 2170.03L255.398 2154.34V2122.94L285.678 2107.25L315.969 2122.94V2154.34Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.678 2107.25L255.399 2122.94L225.119 2107.25V2075.85L255.399 2060.14L285.678 2075.85V2107.25Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.969 2060.14L285.678 2075.85L255.398 2060.14V2028.76L285.678 2013.05L315.969 2028.76V2060.14Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.678 2013.05L255.399 2028.76L225.119 2013.05V1981.65L255.399 1965.96L285.678 1981.65V2013.05Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.969 1965.96L285.678 1981.65L255.398 1965.96V1934.56L285.678 1918.87L315.969 1934.56V1965.96Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.678 1918.87L255.399 1934.56L225.119 1918.87V1887.47L255.399 1871.78L285.678 1887.47V1918.87Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.969 1871.78L285.678 1887.48L255.398 1871.78V1840.38L285.678 1824.68L315.969 1840.38V1871.78Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.678 1824.68L255.399 1840.38L225.119 1824.68V1793.29L255.399 1777.59L285.678 1793.29V1824.68Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.248 2295.62L315.969 2311.31L285.678 2295.62V2264.22L315.969 2248.52L346.248 2264.22V2295.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.528 2248.52L346.248 2264.22L315.969 2248.52V2217.12L346.248 2201.42L376.528 2217.12V2248.52Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.248 2201.42L315.969 2217.12L285.678 2201.42V2170.03L315.969 2154.33L346.248 2170.03V2201.42Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.528 2154.34L346.248 2170.03L315.969 2154.34V2122.94L346.248 2107.25L376.528 2122.94V2154.34Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.248 2107.25L315.969 2122.94L285.678 2107.25V2075.85L315.969 2060.14L346.248 2075.85V2107.25Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.528 2060.14L346.248 2075.85L315.969 2060.14V2028.76L346.248 2013.05L376.528 2028.76V2060.14Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.248 2013.05L315.969 2028.76L285.678 2013.05V1981.65L315.969 1965.96L346.248 1981.65V2013.05Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.528 1965.96L346.248 1981.65L315.969 1965.96V1934.56L346.248 1918.87L376.528 1934.56V1965.96Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.248 1918.87L315.969 1934.56L285.678 1918.87V1887.47L315.969 1871.78L346.248 1887.47V1918.87Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.528 1871.78L346.248 1887.48L315.969 1871.78V1840.38L346.248 1824.68L376.528 1840.38V1871.78Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.248 1824.68L315.969 1840.38L285.678 1824.68V1793.29L315.969 1777.59L346.248 1793.29V1824.68Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.819 2295.62L376.528 2311.31L346.248 2295.62V2264.22L376.528 2248.52L406.819 2264.22V2295.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.098 2248.52L406.818 2264.22L376.527 2248.52V2217.12L406.818 2201.42L437.098 2217.12V2248.52Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.819 2201.42L376.528 2217.12L346.248 2201.42V2170.03L376.528 2154.33L406.819 2170.03V2201.42Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.098 2154.34L406.818 2170.03L376.527 2154.34V2122.94L406.818 2107.25L437.098 2122.94V2154.34Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.819 2107.25L376.528 2122.94L346.248 2107.25V2075.85L376.528 2060.14L406.819 2075.85V2107.25Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.098 2060.14L406.818 2075.85L376.527 2060.14V2028.76L406.818 2013.05L437.098 2028.76V2060.14Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.819 2013.05L376.528 2028.76L346.248 2013.05V1981.65L376.528 1965.96L406.819 1981.65V2013.05Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.098 1965.96L406.818 1981.65L376.527 1965.96V1934.56L406.818 1918.87L437.098 1934.56V1965.96Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.819 1918.87L376.528 1934.56L346.248 1918.87V1887.47L376.528 1871.78L406.819 1887.47V1918.87Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.098 1871.78L406.818 1887.48L376.527 1871.78V1840.38L406.818 1824.68L437.098 1840.38V1871.78Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.819 1824.68L376.528 1840.38L346.248 1824.68V1793.29L376.528 1777.59L406.819 1793.29V1824.68Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.378 2295.62L437.098 2311.31L406.818 2295.62V2264.22L437.098 2248.52L467.378 2264.22V2295.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.668 2248.52L467.377 2264.22L437.098 2248.52V2217.12L467.377 2201.42L497.668 2217.12V2248.52Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.378 2201.42L437.098 2217.12L406.818 2201.42V2170.03L437.098 2154.33L467.378 2170.03V2201.42Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.668 2154.34L467.377 2170.03L437.098 2154.34V2122.94L467.377 2107.25L497.668 2122.94V2154.34Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.378 2107.25L437.098 2122.94L406.818 2107.25V2075.85L437.098 2060.14L467.378 2075.85V2107.25Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.668 2060.14L467.377 2075.85L437.098 2060.14V2028.76L467.377 2013.05L497.668 2028.76V2060.14Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.378 2013.05L437.098 2028.76L406.818 2013.05V1981.65L437.098 1965.96L467.378 1981.65V2013.05Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.668 1965.96L467.377 1981.65L437.098 1965.96V1934.56L467.377 1918.87L497.668 1934.56V1965.96Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.378 1918.87L437.098 1934.56L406.818 1918.87V1887.47L437.098 1871.78L467.378 1887.47V1918.87Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.668 1871.78L467.377 1887.48L437.098 1871.78V1840.38L467.377 1824.68L497.668 1840.38V1871.78Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.378 1824.68L437.098 1840.38L406.818 1824.68V1793.29L437.098 1777.59L467.378 1793.29V1824.68Z",
    stroke: "white",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_384_21",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.6426 890.791) rotate(90) scale(322.75 281.475)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D20B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9049F5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_384_21",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(550.777 1454.99) rotate(90) scale(218.423 190.49)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9049F5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_384_21",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(779 399.164) rotate(90) scale(218.423 190.49)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9049F5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_384_21",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(79.1168 73.9703) rotate(90) scale(218.423 190.49)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_384_21",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(720.832 2216.62) rotate(90) scale(218.423 190.49)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9049F5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_384_21",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.9488 1891.42) rotate(90) scale(218.423 190.49)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_384_21"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 779,
    height: 2269,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_384_21"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1697,
    height: 1052.91,
    fill: "white",
    transform: "translate(-89 -64)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_384_21"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1697,
    height: 1052.91,
    fill: "white",
    transform: "translate(-89 973.086)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFondoCell);
export default __webpack_public_path__ + "static/media/fondo_cell.444c60aa521a07ea5b8a6a7417aecdf0.svg";
export { ForwardRef as ReactComponent };